import useFetchCRMObjects from './useFetchCRMObjects';
import useLaboratoryTreatments from './useLaboratoryTreatments';
import { ANALYTICS_SUB_SUITE_IDS } from 'reporting-discover-components/constants/AnalyticsSubSuiteIds';
const reportCategoryIdToCRMObjectTypeId = {
  [ANALYTICS_SUB_SUITE_IDS.INVOICES]: '0-53',
  [ANALYTICS_SUB_SUITE_IDS.SUBSCRIPTIONS]: '0-69',
  [ANALYTICS_SUB_SUITE_IDS.PAYMENTS]: '0-101'
};
const useCommerceCRMRecordReportZeroState = categoryId => {
  const crmObjectTypeId = reportCategoryIdToCRMObjectTypeId[categoryId];
  const {
    isInTACQ0004VariationGroup
  } = useLaboratoryTreatments();
  const {
    hasCRMObjects
  } = useFetchCRMObjects(crmObjectTypeId, !isInTACQ0004VariationGroup);
  return isInTACQ0004VariationGroup && hasCRMObjects === false;
};
export default useCommerceCRMRecordReportZeroState;